import { m } from '@pricedrop/i18n';
import TrendingDown from 'lucide-react/dist/esm/icons/trending-down';
import { itemsHref } from '@/routes/items/-search-params';
import { FeaturedCategorySection } from './featured-category-section';

interface ItemData {
  uin: number;
  name: string;
  uinsql: string;
  brandName: string;
  price: number | null;
  highestPrice: number;
  lowestPrice: number;
  meanPrice: number;
  previousPrice: number;
}

interface PriceDropsSectionProps {
  items?: ItemData[] | null;
  loading?: boolean;
}

export function PriceDropsSection({ items, loading }: PriceDropsSectionProps) {
  return (
    <FeaturedCategorySection
      title={m.home_recentPriceDrops()}
      icon={<TrendingDown className="h-5 w-5 text-emerald-500" />}
      items={items}
      loading={loading}
      viewAllHref={itemsHref({ afterDropOnly: true })}
      accentClassName="bg-gradient-to-b from-emerald-500 to-emerald-600"
    />
  );
}
